module.exports = __webpack_public_path__ + "static/media/partners.17dc2baa.png";